<template>
  <section>
    <form v-on:submit.prevent="save" disabled>
      <div class="row mt-5">
        <div class="col-12">
          <div class="card shadow-sm mb-4 border-0">
            <div class="card-header background-primary">
              <span class="h4 font-weight-medium text-white mb-0">
                Nilai UTBK
              </span>
            </div>
            <div class="card-body px-5">
              <div class="row">
                <div class="col-md col-12">
                  <div class="row mb-1 align-items-center">
                    <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                      <label
                        class="font-weight-medium text-muted mb-0 h4 form-divider"
                        >Nomor Peserta UTBK-SNBT</label
                      >
                    </div>
                    <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                      <!--<input v-model="form.nisn" typ="text" class="form-control form-control-sm" required />-->
                      <input
                        v-model="form.nisn"
                        typ="text"
                        class="form-control form-control-sm"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col-1 d-none d-md-block"></div>
                <!--<div class="col d-none d-md-block"></div>-->
              </div>

              <div class="row">
                <template v-for="(utbkIndex, index) in utbkIndexes">
                  <div class="col-md col-12" v-if="form.utbk[index]">
                    <div class="row mb-1 align-items-center">
                      <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                        <!--<label class="font-weight-medium text-muted mb-0 h4 form-divider">Jurusan UTBK {{ index + 1 }} </label>-->
                        <label
                          class="font-weight-medium text-muted mb-0 h4 form-divider"
                          >Jurusan UTBK
                        </label>
                      </div>
                      <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                        <multiselect
                          v-model="selectedCourseCategories[index]"
                          v-bind:options="courseCategories"
                          tag-placeholder=""
                          select-label=""
                          deselect-label=""
                          v-bind:allow-empty="false"
                          label="name"
                          track-by="name"
                          placeholder="Jurusan"
                          class="form-control form-control-sm"
                          required
                        >
                        </multiselect>
                      </div>
                    </div>
                    <template v-if="form.utbk[index].courseCategoryID">
                      <div class="row mb-1 align-items-center">
                        <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                          <label
                            class="font-weight-medium mb-0 h4 form-divider text-muted"
                            >File Kartu Peserta UTBK-SNBT</label
                          >
                        </div>
                        <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                          <input
                            v-bind:id="'utbk-file-' + index"
                            type="file"
                            class="form-control"
                            v-on:change="change($event, index)"
                            placeholder="Choose File"
                            accept=".pdf, .png, .jpg, .jpeg"
                          />
                          <label
                            v-bind:for="'utbk-file-' + index"
                            class="form-control form-control-sm text-truncate mb-0"
                          >
                            <button
                              type="button"
                              class="btn btn-danger btn-sm font-weight-bold"
                            >
                              Choose File
                            </button>
                            <template v-if="form.utbk[index]">
                              {{ form.utbk[index].file.name }}
                            </template>
                          </label>
                        </div>
                      </div>
                      <div class="row mb-1 align-items-center">
                        <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                          <label
                            class="font-weight-medium text-muted mb-0 h4 form-divider"
                            >Tanggal UTBK (Bisa Diganti Sesuai Pilihan Siswa)
                          </label>
                        </div>
                        <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                          <datepicker
                            v-model="form.utbk[index].date"
                            v-bind:language="dateLanguage"
                            full-month-name
                            monday-first
                            clear-button
                            input-class="form-control form-control-sm"
                            required
                          ></datepicker>
                        </div>
                      </div>
                      <!--<div class="row mb-1 align-items-center">
                                                <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Penalaran Umum</label>
                                                </div>
                                                <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                    <input v-model.number="form.utbk[index].penalaranUmum" type="number" pattern="^\d*(\.\d{0,2})?$" class="form-control form-control-sm" min="0" max="999999" required />
                                                </div>
                                            </div>
                                            
                                            
                                            <div class="row mb-1 align-items-center">
                                                <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kemampuan Memahami Bacaan & Menulis</label>
                                                </div>
                                                <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                    <input v-model.number="form.utbk[index].pemahamanBacaan" type="number" class="form-control form-control-sm" min="0" max="999999" required />
                                                </div>
                                            </div>
					    <div class="row mb-1 align-items-center">
                                                <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pengetahuan & Pemahaman Umum</label>
                                                </div>
                                                <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                    <input v-model.number="form.utbk[index].pengetahuanUmum" type="number" class="form-control form-control-sm" min="0" max="999999" required />
                                                </div>
                                            </div>
					    <div class="row mb-1 align-items-center">
                                                <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pengetahuan Kuantitatif</label>
                                                </div>
                                                <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                    <input v-model.number="form.utbk[index].pengetahuanKuantitatif" type="number" class="form-control form-control-sm" min="0" max="999999" required />
                                                </div>
                                            </div>
                                            <template v-if="selectedCourseCategories[index]">
                                                <template v-for="(courseCategorySubject, courseIndex) in selectedCourseCategories[index].courseCategorySubjects">
                                                    <div class="row mb-1 align-items-center">
                                                        <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ courseCategorySubject.name }}</label>
                                                        </div>
                                                        <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                            <input v-model.number="form.utbk[index].course[courseIndex].score" type="number" class="form-control form-control-sm" min="0" max="999999" required />
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>-->
                      <div class="row mb-1 align-items-center">
                        <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                          <label
                            class="font-weight-medium text-muted mb-0 h4 form-divider"
                            >Nilai Rataan 3 TO Tertinggi</label
                          >
                        </div>
                        <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                          <input
                            class="form-control form-control-sm"
                            type="number"
                            disabled
                            v-bind:value="total(index)"
                          />
                        </div>
                      </div>
                      <!--<div class="row mb-1 align-items-center">
                                                <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nilai Rataan</label>
                                                </div>
                                                <div class="col-lg-5 col-md-12 col-sm-5 px-1">
                                                    <input class="form-control form-control-sm" type="number" disabled v-bind:value="average(index)" />
                                                </div>
                                            </div>-->
                    </template>
                  </div>
                  <div class="col-1 d-none d-md-block" v-if="!index"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12" v-for="(utbkIndex, index) in universityIndexes">
          <div
            class="card shadow-sm mb-4 border-0"
            v-if="form.utbk[index] && form.utbk[index].courseCategoryID"
          >
            <div class="card-header background-primary">
              <span class="h4 font-weight-medium text-white mb-0">
                Prodi Pilihan {{ index + 1 }}
              </span>
            </div>
            <div class="card-body px-5">
              <div class="row mb-1 align-items-center">
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Universitas Pilihan</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <multiselect
                    v-bind:id="'multiselect-university-' + index"
                    v-model="selectedUniversities[index]"
                    v-bind:options="universities"
                    tag-placeholder=""
                    select-label=""
                    label="name"
                    track-by="name"
                    v-bind:placeholder="'Univ ' + (index + 1)"
                    class="form-control form-control-sm"
                  >
                  </multiselect>
                </div>
              </div>
              <div
                class="row mb-1 align-items-center"
                v-if="universityCourses[utbkIndex]"
              >
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Prodi Pilihan</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <multiselect
                    v-model="selectedUniversityCourses[index]"
                    v-on:select="
                      (universityCourse) =>
                        (form[utbkIndex + 'CourseID'] = universityCourse.id)
                    "
                    v-on:remove="() => (form[utbkIndex + 'CourseID'] = '')"
                    v-bind:options="universityCourses[utbkIndex]"
                    tag-placeholder=""
                    select-label=""
                    label="name"
                    track-by="name"
                    v-bind:placeholder="'Prodi ' + (index + 1)"
                    class="form-control form-control-sm"
                  >
                  </multiselect>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Peringkat Anda di Prodi Pilihan</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <h4
                    class="font-weight-medium mb-0"
                    v-if="student.studentUniversityCourse"
                  >
                    {{
                      student.studentUniversityCourse[utbkIndex + "CourseRank"]
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Jumlah Peminat di Prodi Pilihan Anda</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <h4
                    class="font-weight-medium mb-0"
                    v-if="student.studentUniversityCourse"
                  >
                    {{
                      student.studentUniversityCourse[
                        utbkIndex + "CourseApplicant"
                      ]
                    }}
                  </h4>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Nilai Tertinggi di Prodi Pilihan Anda</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <h4
                    class="font-weight-medium mb-0"
                    v-if="student.studentUniversityCourse"
                  >
                    {{
                      student.studentUniversityCourse[utbkIndex + "CourseTop"]
                    }}
                  </h4>
                </div>
              </div>
              <!--<div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kuota SBMPTN</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <h4 class="font-weight-medium mb-0" v-if="student.studentUniversityCourse && student.studentUniversityCourse[utbkIndex + 'Course']">
                                        {{ student.studentUniversityCourse[utbkIndex + 'Course'].graduates }}
                                    </h4>
                                </div>
                            </div>-->
              <div class="row mb-1 align-items-center">
                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                  <label
                    class="font-weight-medium text-muted mb-0 h4 form-divider"
                    >Peringkat Anda di Seluruh Peserta BTA Berdasarkan Rataan 3 TO Tertinggi</label
                  >
                </div>
                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                  <h4
                    class="font-weight-medium mb-0"
                    v-if="
                      student.studentUniversityCourse &&
                      student.studentUniversityCourse[
                        utbkIndex + 'CategoryRank'
                      ]
                    "
                  >
                    {{
                      student.studentUniversityCourse[
                        utbkIndex + "CategoryRank"
                      ]
                    }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-auto">
          <button type="submit" class="btn btn-sm btn-danger px-5">Save</button>
        </div>
      </div>
    </form>
    <div class="iframe-container">
  <iframe
    src="https://lookerstudio.google.com/embed/reporting/7ca08809-2f48-42eb-b680-2a23f49cfbb1/page/sOhrF"
    allowfullscreen
  ></iframe>
</div>
    <div class="row">
      <div class="col text-center mt-5">
        <Adsense
          v-bind:data-ad-client="googleAdsClientKey"
          data-ad-slot="6426122373"
        ></Adsense>
      </div>
    </div>
  </section>
</template>

<script>
import { id } from "vuejs-datepicker/dist/locale";
import Multiselect from "vue-multiselect";
import FileIcon from "@/components/item/FileIcon";
import Datepicker from "vuejs-datepicker";
import qs from "qs";

export default {
  name: "AccountStudentUTBK",
  components: {
    Multiselect,
    FileIcon,
    Datepicker,
  },
  watch: {
    selectedCourseCategories: {
      handler(courseCategories) {
        for (let index in courseCategories) {
          if (courseCategories[index]) {
            for (let courseIndex in courseCategories[index]
              .courseCategorySubjects) {
              let utbkCourseScore = null;
              let utbkScore = this.student.utbkScores[index];
              if (utbkScore) {
                utbkCourseScore = utbkScore.utbkCourseScores.find(
                  (utbkCourseScore) =>
                    utbkCourseScore.courseCategorySubjectID ===
                    courseCategories[index].courseCategorySubjects[courseIndex]
                      .id
                );
              }
              if (utbkCourseScore) {
                this.form.utbk[index].course[courseIndex] = utbkCourseScore;
              } else {
                this.form.utbk[index].course[courseIndex] = {
                  courseCategorySubjectID:
                    courseCategories[index].courseCategorySubjects[courseIndex]
                      .id,
                  score: 0,
                };
              }
              this.form.utbk[index].courseCategoryID =
                courseCategories[index].id;
            }
          } else {
            this.form.utbk[index].courseCategoryID = "";
          }
        }
      },
      deep: true,
    },
    selectedUniversities: {
      handler(universities) {
        for (let index in universities) {
          if (universities[index]) {
            this.axios
              .get(process.env.API_URL + "/university-course", {
                params: {
                  universityID: universities[index].id,
                  courseCategoryID: this.form.utbk
                    .map((utbk) => utbk.courseCategoryID)
                    .filter((value) => value),
                  pagination: 0,
                },
              })
              .then((response) => {
                this.universityCourses[this.utbkIndexes[index]] =
                  response.data.data.data;
              });
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      form: {
        nisn: "",
        firstCourseID: "",
        googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
        secondCourseID: "",
        utbk: [],
      },
      totalUTBK: 0,
      utbkIndexes: ["first"],
      universityIndexes: ["first", "second"],
      student: { user: {}, additionals: {} },
      courseCategories: [],
      selectedCourseCategories: [],
      selectedUniversities: [],
      selectedUniversityCourses: [],
      universities: [],
      universityCourses: { first: [], second: [] },
      dateLanguage: id,
    };
  },
  methods: {
    save() {
      var formData = new FormData();
      for (var group in this.form) {
        var value = this.form[group];
        if (typeof value === "object") {
          for (var groupIndex in this.form[group]) {
            for (var attribute in this.form[group][groupIndex]) {
              if (this.form[group][groupIndex].courseCategoryID) {
                value = this.form[group][groupIndex][attribute];
                if (value instanceof Date) {
                  formData.set(
                    group + "[" + groupIndex + "][" + attribute + "]",
                    this.$moment(value).format("YYYY-MM-DD")
                  );
                } else if (
                  typeof value === "object" &&
                  Object.keys(value).length
                ) {
                  for (var indexAttribute in this.form[group][groupIndex][
                    attribute
                  ]) {
                    value =
                      this.form[group][groupIndex][attribute][indexAttribute];
                    if (typeof value === "object") {
                      for (var property in this.form[group][groupIndex][
                        attribute
                      ][indexAttribute]) {
                        value =
                          this.form[group][groupIndex][attribute][
                            indexAttribute
                          ][property];
                        if (typeof value !== "object") {
                          formData.set(
                            group +
                              "[" +
                              groupIndex +
                              "][" +
                              attribute +
                              "][" +
                              indexAttribute +
                              "][" +
                              property +
                              "]",
                            value
                          );
                        }
                      }
                    }
                  }
                } else {
                  formData.set(
                    group + "[" + groupIndex + "][" + attribute + "]",
                    value
                  );
                }
              }
            }
          }
        } else {
          formData.set(group, value);
        }
      }
      this.axios
        .post(process.env.API_URL + "/student/upload-utbk", formData)
        .then((response) => {
          if (response.data.status) {
            this.fetchData();
            this.$toastr("success", response.data.message, "Success");
          } else {
            this.$toastr(
              "warning",
              response.data.errors[Object.keys(response.data.errors)[0]][0],
              "Warning"
            );
          }
        });
    },
    fetchData() {
      this.axios
        .get(process.env.API_URL + "/student/profile")
        .then((response) => {
          this.student = response.data.data;
          if (parseInt(this.student.btaGrade.level) < 12) {
            this.$router.replace({
              name: "error",
              params: { code: 404, message: "Page not found" },
            });
          }

          if (this.student.studentUniversityCourse) {
            this.form = Object.assign(
              {},
              this.student.studentUniversityCourse,
              { nisn: "", utbk: [] }
            );
            this.selectedUniversities = [];
            this.selectedUniversityCourses = [];
            for (let index in this.utbkIndexes) {
              if (
                this.student.studentUniversityCourse[
                  this.utbkIndexes[index] + "Course"
                ]
              ) {
                this.selectedUniversities.push(
                  this.student.studentUniversityCourse[
                    this.utbkIndexes[index] + "Course"
                  ].university
                );
                this.selectedUniversityCourses.push(
                  this.student.studentUniversityCourse[
                    this.utbkIndexes[index] + "Course"
                  ]
                );
              }
            }
          }

          this.form.utbk = [];
          this.selectedCourseCategories = [];
          for (let index in this.utbkIndexes) {
            if (this.student.utbkScores[index]) {
              this.form.nisn =
                this.form.nisn || this.student.utbkScores[index].nisn;
              this.form.utbk.push(
                Object.assign({}, this.student.utbkScores[index], {
                  file: "",
                  course: [],
                })
              );

              this.selectedCourseCategories.push(
                this.student.utbkScores[index].courseCategory
              );
            } else {
              this.form.utbk.push({
                courseCategoryID: "",
                penalaranUmum: 0,
                pengetahuanKuantitatif: 0,
                pengetahuanUmum: 0,
                pemahamanBacaan: 0,
                file: "",
                date: "2020-06-02",
                course: [],
              });
            }
          }
        });
    },
    change(event, index) {
      var input = event.currentTarget;
      if (input.files && input.files[0]) {
        this.form.utbk[index].file = input.files[0];
      }
    },
    total(index) {
      let total = 0;
      total += this.form.utbk[index].penalaranUmum || 0;
      total += this.form.utbk[index].pengetahuanKuantitatif || 0;
      total += this.form.utbk[index].pengetahuanUmum || 0;
      total += this.form.utbk[index].pemahamanBacaan || 0;
      for (let courseIndex in this.form.utbk[index].course) {
        total += this.form.utbk[index].course[courseIndex].score || 0;
      }
      return total;
    },
    average(index) {
      let average = 0;
      average += this.form.utbk[index].penalaranUmum || 0;
      average += this.form.utbk[index].pengetahuanKuantitatif || 0;
      average += this.form.utbk[index].pengetahuanUmum || 0;
      average += this.form.utbk[index].pemahamanBacaan || 0;
      for (let courseIndex in this.form.utbk[index].course) {
        average += this.form.utbk[index].course[courseIndex].score || 0;
      }
      return average / 4;
    },
  },
  created() {
    this.fetchData();

    Promise.all([
      this.axios.get(process.env.API_URL + "/course-category"),
      this.axios.get(process.env.API_URL + "/university"),
    ]).then((response) => {
      this.courseCategories = response[0].data.data;
      this.universities = response[1].data.data;
    });

    document.title = "Laporan UTBK - " + process.env.APP_NAME;
  },
};
</script>

<style scoped>
@media (min-width: 768px) and (max-width: 991.98px), (max-width: 575.98px) {
  .form-divider::before {
    display: none;
  }
}

.iframe-container {
  width: 100%;
  max-width: 1500px;
  aspect-ratio: 3 / 2;
  margin:0 auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/account/student/UTBK.vue